import React, { useState } from 'react';
import { Modal, Button, message } from 'antd';
import { deleteUploads } from '../../utils/services/uploadAPI';
import { ModalBody, Container } from './styles';
import { useTranslation } from 'react-i18next';
import { DESIGN_AREA_UPLOADS_TAB } from '../../containers/SidebarMenu/translationValues';

const NAMESPACES = ['DESIGN_AREA_UPLOADS_TAB'];

const DeleteImageModal = props => {
  const { visible, onCancel, target, type = '', displayText, onDeleteImage } = props;
  const { t } = useTranslation(NAMESPACES);
  const [deleting, setDeleting] = useState(false);

  const onDelete = async () => {
    const payload = {
      id: target.id,
    };
    setDeleting(true);
    let deletionResponse;
    switch (type) {
      case 'image':
        deletionResponse = await deleteUploads(payload);
        break;
      default:
        setDeleting(false);
        onCancel();
        break;
    }
    if (deletionResponse && deletionResponse?.statusCode === 203) {
      setDeleting(false);
      onCancel();
      handleResponse();
    } else {
      setDeleting(false);
      message.error(t(DESIGN_AREA_UPLOADS_TAB.IMAGE_DELETE_ERROR_MESSAGE.key, DESIGN_AREA_UPLOADS_TAB.IMAGE_DELETE_ERROR_MESSAGE.value));
    }
  };

  const handleResponse = () => {
    switch (type) {
      case 'image':
        onDeleteImage(target, 'deleteUploadElement');
        break;
      default:
        break;
    }
    message.success(t(DESIGN_AREA_UPLOADS_TAB.IMAGE_DELETE_SUCCESS_MESSAGE.key, DESIGN_AREA_UPLOADS_TAB.IMAGE_DELETE_SUCCESS_MESSAGE.value));
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={
          t(DESIGN_AREA_UPLOADS_TAB.DELETE_IMAGE_MODAL_TITLE.key, DESIGN_AREA_UPLOADS_TAB.DELETE_IMAGE_MODAL_TITLE.value) +
          ' ' +
          (type === 'image' ? displayText : type)
        }
        centered
        visible={visible}
        width="625px"
        onCancel={onCancel}
        footer={[
          <Button key="back" onClick={onCancel}>
            {t(DESIGN_AREA_UPLOADS_TAB.CANCEL_BUTTON.key, DESIGN_AREA_UPLOADS_TAB.CANCEL_BUTTON.value)}
          </Button>,
          <Button key="submit" type="primary" loading={deleting} onClick={onDelete}>
          {deleting
            ? t(DESIGN_AREA_UPLOADS_TAB.DELETING_BUTTON.key, DESIGN_AREA_UPLOADS_TAB.DELETING_BUTTON.value)
            : t(DESIGN_AREA_UPLOADS_TAB.DELETE_BUTTON.key, DESIGN_AREA_UPLOADS_TAB.DELETE_BUTTON.value)}
        </Button>,
        ]}
        className="warning-modal"
      >
        <ModalBody>
          <div className="warning-text">
            <span>{t(DESIGN_AREA_UPLOADS_TAB.IMAGE_DELETE_CONFIRMATION.key, DESIGN_AREA_UPLOADS_TAB.IMAGE_DELETE_CONFIRMATION.value)}</span>
            {target && target.name && <span className="text-highlighter">{target.name}</span>}
            <span>{type === 'image' ? displayText : type}</span>
            {target && target.categoryName && (
              <>
                <span>{t(DESIGN_AREA_UPLOADS_TAB.IMAGE_UNDER.key, DESIGN_AREA_UPLOADS_TAB.IMAGE_UNDER.value)}</span>
                <span className="text-highlighter">{target.categoryName}</span>
                <span>{t(DESIGN_AREA_UPLOADS_TAB.IMAGE_CATEGORY.key, DESIGN_AREA_UPLOADS_TAB.IMAGE_CATEGORY.value)}</span>
              </>
            )}
            <span>?</span>
          </div>
        </ModalBody>
      </Modal>
    </Container>
  );
};
export default DeleteImageModal;
